import {TimeState, TimerStatus} from '@/stores/TimerStore/TimerStore.types';

import {injected} from 'brandi';

import {Store} from '@/stores/Store';
import {FormatUtils, TimeFormat} from '@/utils/FormatUtils';

export class TimerStore extends Store<TimeState> {
  constructor() {
    super({
      formattedTime: '',
      seconds: 0,
      status: TimerStatus.INITIAL,
    });
  }

  public init(nextValueInTime: number, timeFormat: TimeFormat): void {
    this.setState({
      formattedTime: FormatUtils.formatTime(nextValueInTime, timeFormat),
      seconds: nextValueInTime,
      status: TimerStatus.INITIAL,
    });
  }

  public updateTimer(newState: Partial<TimeState>): void {
    this.setState({
      ...this.getState(),
      ...newState,
    });
  }

  public setTimerFinished(): void {
    this.setState({
      ...this.getState(),
      status: TimerStatus.FINISHED,
    });
  }

  public setTimerStopped(): void {
    this.setState({
      ...this.getState(),
      status: TimerStatus.STOPPED,
    });
  }

  public setTimerPaused(): void {
    this.setState({
      ...this.getState(),
      status: TimerStatus.PAUSED,
    });
  }

  public setTimerRunning(): void {
    this.setState({
      ...this.getState(),
      status: TimerStatus.RUNNING,
    });
  }

  public isInitStatus(): boolean {
    return this.getState().status === TimerStatus.INITIAL;
  }

  public isRunningStatus(): boolean {
    return this.getState().status === TimerStatus.RUNNING;
  }

  public isStoppedStatus(): boolean {
    return this.getState().status === TimerStatus.STOPPED;
  }

  public isPausedStatus(): boolean {
    return this.getState().status === TimerStatus.PAUSED;
  }

  public isFinishedStatus(): boolean {
    return this.getState().status === TimerStatus.FINISHED;
  }
}

injected(TimerStore);
